import Events from 'events';

class SessionManager extends Events.EventEmitter {
  constructor() {
    super();

    this._session = null;

    this.SESSION_CHANGED = 'sessionChanged';
  }

  init() {
    const EventType = window.cast.framework.CastContextEventType;

    const sessionStateListener = this._sessionStateListener.bind(this);

    const castContext = window.cast.framework.CastContext.getInstance();
    castContext.addEventListener(EventType.SESSION_STATE_CHANGED, sessionStateListener);
  }

  _sessionStateListener(event) {
    const SessionState = window.cast.framework.SessionState;
    const session = event.session;

    switch (event.sessionState) {
      case SessionState.SESSION_STARTED:
        this._updateSession(session, true);
        break;
      case SessionState.SESSION_RESUMED:
        this._updateSession(session, false);
        break;

      default:
        this._updateSession(null, true);
    }
  }

  _updateSession(session, notify) {
    if (this._session === session) {
      return;
    }

    this._session = session;

    if (notify) {
      this.emit(this.SESSION_CHANGED, this._session);
    }
  }

  addSessionChangedListener(listener) {
    this.on(this.SESSION_CHANGED, listener);
  }

  getSession() {
    return this._session;
  }
}

export default new SessionManager();



// WEBPACK FOOTER //
// ./src/services/chromecast/session_manager.js